import React, { useCallback } from 'react'

import ModalCloseButton from 'components/modals/v2/modal_close_button'
import ModalStandardWrapper from 'components/modals/v2/modal_standard_wrapper'
import AddCard from 'components/views/logged_in/menu/payment_settings/add_card'
import { useBookeePaymentCapabilitiesSelector } from 'store/selectors'

const AddCardModal = ({ modalProps = {}, onClose }) => {
  const { onAddCard } = modalProps
  const bookeePaymentCapabilities = useBookeePaymentCapabilitiesSelector()

  const handleAddCarded = useCallback(
    (setupIntent) => {
      if (!onAddCard) return
      onAddCard(setupIntent.payment_method)
    },
    [onAddCard]
  )

  return (
    <ModalStandardWrapper $minWidth="440px">
      <ModalCloseButton onClose={onClose} />

      <AddCard
        border="none"
        submitLabel="Add Card"
        onCancel={onClose}
        onError={alert}
        onCardAdded={handleAddCarded}
        bookeePaymentCapabilities={bookeePaymentCapabilities?.supported_payment_method_types}
      />
    </ModalStandardWrapper>
  )
}

export default AddCardModal
